import React from "react";
import {
  FaRuler,
  FaUser,
  FaRulerCombined,
  FaTasks,
  FaClipboardCheck,
  FaFileContract,
  FaCamera,
  FaUserPlus,
  FaFileInvoiceDollar,
} from "react-icons/fa";

import SkillsCateg from "./SkillsCateg";
import { Container } from "react-bootstrap";
import { FaHtml5, FaCss3Alt, FaJs, FaReact, FaBootstrap, FaNodeJs, FaDatabase, FaFire } from "react-icons/fa";

const Skills = () => {

    const templatesData = [
       
        { icon: <FaHtml5 />, text: "HTML" },
        { icon: <FaCss3Alt />, text: "CSS" },
        { icon: <FaJs />, text: "JavaScript" },
        { icon: <FaReact />, text: "ReactJS" },
        { icon: <FaBootstrap />, text: "Bootstrap" },
        { icon: <FaNodeJs />, text: "ExpressJS" }, // Using FaNodeJs as a close alternative to represent ExpressJS
        { icon: <FaDatabase />, text: "MongoDB" }, // Using FaDatabase to represent MongoDB
        { icon: <FaFire />, text: "Firebase" }
      ];

  return (
    <Container>
      <h2 className="sec-title">
        Skills
      </h2>
      <SkillsCateg templates={templatesData} />
    </Container>
  );
};

export default Skills;
